var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    { staticClass: "table-display-column" },
    [
      _c(
        "el-popover",
        {
          attrs: {
            placement: "bottom-end",
            trigger: "click",
            "popper-class": "table-display-column-popper",
          },
          on: { show: _vm.openDialog, hide: _vm.handlePopoverHide },
          model: {
            value: _vm.popoverVisible,
            callback: function ($$v) {
              _vm.popoverVisible = $$v
            },
            expression: "popoverVisible",
          },
        },
        [
          _c(
            "div",
            { staticClass: "table-display-column-box" },
            [
              _c(
                "el-checkbox",
                {
                  attrs: {
                    indeterminate:
                      _vm.edit_rows.length !== _vm.getAlltableColumnLen &&
                      _vm.edit_rows.length !== 0,
                  },
                  on: { change: _vm.selectAllDisplay },
                  model: {
                    value: _vm.select_all,
                    callback: function ($$v) {
                      _vm.select_all = $$v
                    },
                    expression: "select_all",
                  },
                },
                [_vm._v(" 全选 ")]
              ),
              _c(
                "el-checkbox-group",
                {
                  staticClass: "table-display-column-group",
                  model: {
                    value: _vm.edit_rows,
                    callback: function ($$v) {
                      _vm.edit_rows = $$v
                    },
                    expression: "edit_rows",
                  },
                },
                [
                  _vm._l(_vm.getAlltableColumn, function (item) {
                    return [
                      item.group
                        ? [
                            _c(
                              "el-card",
                              {
                                key: item.prop,
                                staticClass: "mt-10 table-column-display-card",
                                attrs: { shadow: "never", header: item.group },
                              },
                              _vm._l(item.columns_list, function (i) {
                                return _c(
                                  "div",
                                  { key: i.prop + "e" },
                                  [
                                    _c(
                                      "el-checkbox",
                                      {
                                        attrs: {
                                          label: i.prop,
                                          disabled: i.require_column,
                                        },
                                      },
                                      [
                                        _c(
                                          "div",
                                          {
                                            staticClass:
                                              "table-display-column-item",
                                          },
                                          [_vm._v(_vm._s(i.label))]
                                        ),
                                      ]
                                    ),
                                  ],
                                  1
                                )
                              }),
                              0
                            ),
                          ]
                        : item.childrens && item.childrens.length
                        ? [
                            _c(
                              "el-card",
                              {
                                key: item.prop,
                                staticClass: "mt-10 table-column-display-card",
                                attrs: { shadow: "never", header: item.label },
                              },
                              _vm._l(item.childrens, function (i) {
                                return _c(
                                  "div",
                                  { key: i.prop + "i" },
                                  [
                                    _c(
                                      "el-checkbox",
                                      {
                                        attrs: {
                                          label: i.prop,
                                          disabled: i.require_column,
                                        },
                                      },
                                      [
                                        _c(
                                          "div",
                                          {
                                            staticClass:
                                              "table-display-column-item",
                                          },
                                          [_vm._v(_vm._s(i.label))]
                                        ),
                                      ]
                                    ),
                                  ],
                                  1
                                )
                              }),
                              0
                            ),
                          ]
                        : _c(
                            "el-checkbox",
                            {
                              key: item.prop,
                              attrs: {
                                label: item.prop,
                                disabled: item.require_column,
                              },
                            },
                            [
                              _c(
                                "div",
                                { staticClass: "table-display-column-item" },
                                [_vm._v(_vm._s(item.label))]
                              ),
                            ]
                          ),
                    ]
                  }),
                ],
                2
              ),
            ],
            1
          ),
          _c(
            "el-button",
            {
              staticClass: "table-display-column-trigger",
              attrs: { slot: "reference", type: "text" },
              slot: "reference",
            },
            [_c("i", { staticClass: "el-icon-more" })]
          ),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }